var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-input',_vm._g(_vm._b({attrs:{"value":_vm.value,"maxlength":_vm.maxLength},on:{"input":function (val) { return _vm.$emit('input', val); }}},'vs-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }